<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpBox
    alignItems="center"
    class="mb-1"
  >
    <ItpText
      :text="itemName"
      :tooltip="itemName"
      :strikethrough="isServiceStale(item)"
      class="font-weight-bold"
    >
    </ItpText>
    <ItpLink
      :icon="$config.externalLinkIcon"
      :to="{ name: 'app.product', params: { id: item.service.id } }"
      class="pl-1"
    >
    </ItpLink>
    <ItpIcon
      :title="'Locked'|gettext"
      name="fa-lock"
      class="pl-3"
      v-if="item.locked"
    >
    </ItpIcon>
    <UcProductInvoiceGroupLabel
      :value="item.invoice_group_id"
      class="ml-2"
      v-if="item.invoice_group_id"
    >
    </UcProductInvoiceGroupLabel>
    <DIV
      class="ml-2"
    >
      {{ item.valid_from|date }} <span v-if="item.valid_to">-</span>
{{ item.valid_to|date }}

    </DIV>
  </ItpBox>
  <ItpBox
    direction="column"
  >
    <ItpBox
      class="mb-2"
      v-if="item.invoice_notes || (item.transaction_notes && item.transaction_notes.length)"
    >
      <DIV
        class="mx-1"
      >
        <ItpIcon
          icon="uil:notes"
        >
        </ItpIcon>
      </DIV>
      <DIV
        class="flex flex-row"
      >
        <ItpText
          spacing="px-1"
          :text="item.invoice_notes"
          pre
          v-if="item.invoice_notes"
        >
        </ItpText>
        <TransactionNotesDisplay
          v-model="item.transaction_notes"
          v-if="item.transaction_notes && item.transaction_notes.length"
        >
        </TransactionNotesDisplay>
      </DIV>
    </ItpBox>
    <ItpBox
      class="mb-2"
      v-if="item.intermediated_service"
    >
      <DIV
        class="mx-1"
      >
        <ItpIcon
          icon="mingcute:arrows-right-fill"
        >
        </ItpIcon>
      </DIV>
      <ItpText
        spacing="px-1"
        :text="'Intermediated service'|gettext"
      >
      </ItpText>
    </ItpBox>
    <ItpBox
      class="mb-2"
      v-if="item.billing_category"
    >
      <DIV
        class="mx-1"
      >
        <ItpIcon
          icon="ph:circles-three-fill"
        >
        </ItpIcon>
      </DIV>
      <ItpText
        spacing="px-1"
        :text="item.billing_category"
      >
      </ItpText>
    </ItpBox>
    <ItpBox
      class="mb-2"
    >
      <DIV
        class="mx-1"
      >
        <ItpIcon
          icon="uil:cog"
        >
        </ItpIcon>
      </DIV>
      <ItpBox
        wrap-items
      >
        <UcBillingFrequencyDisplay
          :value="item.billing_frequency"
          class="mr-1 mb-1"
          v-if="item.billing_frequency"
        >
        </UcBillingFrequencyDisplay>
        <UcBillingDateRuleDisplay
          :value="item.billing_date_rule"
          class="mr-1 mb-1"
          v-if="item.billing_date_rule"
        >
        </UcBillingDateRuleDisplay>
        <UcDueDateRuleDisplay
          :value="item.due_date_rule"
          class="mr-1 mb-1"
          v-if="item.due_date_rule"
        >
        </UcDueDateRuleDisplay>
        <UcCurrencyBadge
          :value="item.billing_currency"
          class="mr-1 mb-1"
          v-if="item.billing_currency"
        >
        </UcCurrencyBadge>
        <UcExchangeRateDateRuleDisplay
          :value="item.exchange_rate_date_rule"
          :source="item.exchange_rate_source"
          class="mr-1 mb-1"
          v-if="item.exchange_rate_date_rule"
        >
        </UcExchangeRateDateRuleDisplay>
      </ItpBox>
    </ItpBox>
    <ItpBox
      class="mb-2"
      v-if="item.description"
    >
      <DIV
        class="mx-1"
      >
        <ItpIcon
          icon="material-symbols:info-outline"
        >
        </ItpIcon>
      </DIV>
      <ItpText
        spacing="px-1"
        :text="item.description"
        pre
      >
      </ItpText>
    </ItpBox>
  </ItpBox>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractServiceCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  isServiceStale(...args: any[]) {
    const [service] = args;
    return service.valid_to && this.$fn.parseISODate(service.valid_to) < this.today
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  today!: any;

  async $$load_today() {
    return new Date()
  }

  ux!: any;
  dataMembers = ['today', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        today: null,
        ux: null,
      },
    }
  }

  get itemName() {
    if (this.loaded) {

      return this.item.invoice_item_name && this.item.invoice_item_name.length ?
        _.map(this.item.invoice_item_name, 'name').join(' / ') :
        this.item.name
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8880: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8879: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8880 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8879 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8880,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8879],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8880,
      evh_7315092382398562_reload_8879,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("UcContractServiceCard", UcContractServiceCard);

</script>